import { LAYOUT_CONFLICT_ERROR_NAME, type VisualizerInitData } from "../loader";

import { type Notification } from "./Notifications";

/**
 * Seed the workspace's notifications from the loader: the banners it raised
 * for the event, plus the layout error it recovered from. The layout-conflict
 * error is left out because its own modal handles it.
 */
export function initialNotifications(
  initData: VisualizerInitData,
): Notification[] {
  const notifications: Notification[] = initData.notices.map((notice) => ({
    id: notice.name,
    title: notice.title,
    message: notice.message,
    severity: notice.severity,
  }));

  const configSource = initData.configSource;
  if (
    configSource?.type === "recoverable-error" &&
    configSource.value.name !== LAYOUT_CONFLICT_ERROR_NAME
  ) {
    notifications.push({
      id: configSource.value.name,
      title: configSource.value.title,
      message: configSource.value.message,
      severity: "error",
    });
  }

  return notifications;
}
